import { DocumentNode, Kind, SelectionSetNode } from "graphql";
import { OperationDefinitionNode } from "graphql/index";
import { FieldNode, FragmentDefinitionNode } from "graphql/language/ast";
import { get, set } from "object-path";

function cloneValues(selectionSet: SelectionSetNode, parentPath: string, source: Object, destination: Object) {
  const pathPrefix = parentPath ? `${parentPath}.` : "";

  for (const selection of selectionSet.selections) {
    if (selection.kind === Kind.FIELD) {
      const fieldNode = selection as FieldNode;
      const path = pathPrefix + fieldNode.name.value;
      if (fieldNode.selectionSet) {
        const srcValue = get(source, path);
        if (Array.isArray(srcValue)) {
          for (let i = 0; i < srcValue.length; i++) {
            cloneValues(fieldNode.selectionSet, `${path}.${i}`, source, destination);
          }
          if (srcValue.length === 0) {
            set(destination, path, []);
          }
        } else {
          cloneValues(fieldNode.selectionSet, path, source, destination);
        }
      } else {
        set(destination, path, get(source, path));
      }
    }
  }

  const typeName = get(source, pathPrefix + "__typename");
  if (typeName) {
    set(destination, pathPrefix + "__typename", typeName);
  }
}

export function appendDocumentFields<T extends object>(source: Object, destination: T, ...nodes: DocumentNode[]) {
  for (const node of nodes) {
    for (const definition of node.definitions) {
      if (definition.kind !== Kind.FRAGMENT_DEFINITION) {
        throw new Error("Document should be FRAGMENT_DEFINITION type");
      }
      cloneValues((definition as FragmentDefinitionNode).selectionSet, "", source, destination);
    }
  }

  return destination;
}

export function selectDocumentFields<T extends object>(source: Object, ...nodes: DocumentNode[]) {
  return appendDocumentFields<T>(source, {} as T, ...nodes);
}

export function getDocumentsNames(...documents: DocumentNode[]) {
  return documents.map(document => {
    const operationDefinition = document.definitions.find(x => x.kind === "OperationDefinition") as OperationDefinitionNode;
    return operationDefinition?.name?.value as string;
  });
}
